import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { Constants } from '../common/constants';
import { HttpUtils } from '../common/http-utils';
import { Utils } from '../common/utils';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

export interface PaymentReceiptModalModel {
  applicantId: string;
  isV1Application: number;
}

@Component({
  selector: 'app-payment-receipt-modal',
  templateUrl: './payment-receipt-modal.component.html',
  styleUrls: ['./payment-receipt-modal.component.css']
})
export class PaymentReceiptModalComponent extends SimpleModalComponent<PaymentReceiptModalModel, any> implements PaymentReceiptModalModel, OnInit {

  @ViewChild('receiptContent', { static: false }) receiptContent!: ElementRef;

  applicantId: string;
  isV1Application: number;

  paymentReceiptDetails: any = {};
  dateFormat: string = 'dd/mm/yyyy';

  constructor(private httpUtils: HttpUtils, public utils: Utils, public constants: Constants) {
    super();
  }

  ngOnInit() {
    if (this.isV1Application === this.constants.TRUE) {
      this.dateFormat = 'yyyy-mm-dd';
    }
    this.storePaymentReceiptDetails();
  }

  private storePaymentReceiptDetails(): void {
    // console.log('fetchPaymentReceiptData request:', { applicantId: this.applicantId, isV1Application: this.isV1Application });
    this.httpUtils.fetchPaymentReceiptData(this.applicantId, this.isV1Application).then(serverResponse => {
      // console.log('fetchPaymentReceiptData response:', serverResponse);
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.paymentReceiptDetails = serverResponse.paymentReceiptDetails;
      } else {
        // console.warn('fetchPaymentReceiptData failed. responseCode:', serverResponse.responseCode);
        this.close();
      }
    }).catch(error => {
      console.error('fetchPaymentReceiptData error:', error);
      this.close();
    });
  }

  printReceipt(): void {
    window.print();
  }

  downloadPDF(): void {
    const element = this.receiptContent.nativeElement;

    html2canvas(element, {
      scale: 2,
      useCORS: true
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210; // A4 width
      const pageHeight = 295; // A4 height
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const filename = `payment-receipt-${this.paymentReceiptDetails.orderReference || 'receipt'}.pdf`;
      pdf.save(filename);
    }).catch(err => {
      console.error('Error generating PDF:', err);
    });
  }
}
